import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { STATUS_MODEL } from "../../../../../enums/statusEnum";
import {useLocation, useNavigate} from "react-router-dom";
import { useDispatch } from "react-redux";
import {GetInvitationById, UpdateStatusByInvitationId} from "../../../../../reduxToolkit/Invitation/InvitationApi";
import {CustomFieldCardStyle} from "../../../../../components/Styles";
import {getStatusConfig} from "../Model/Model";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 */

export const InvitationDocumentationApp = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    let { state } = location;
    const userId = state?.id;
    const backUrl = state?.backUrl;
    const isOverdue = backUrl?.state?.isOverdue;
    const [showApprove, setShowApprove] = useState(false);
    const [showDenied, setShowDenied] = useState(false);
    const [showIssueComment, setShowIssueComment] = useState(false);
    const [modified, setModified] = useState(false);
    const [row, setRow] = useState(null);
    const [resultsToShow, setResultsToShow] = useState(null);
    const [disabled, setDisabled] = useState(false);
    const [pendingToUpload, setPendingToUpload] = useState(true);
    // Holds the current card styling config, recalculated on invitation status change
    const [currentStatusConfig, setCurrentStatusConfig] = useState(null);
    const [showButtonsToApprove, setShowButtonsToApprove] = useState(false);
    // Generic modal configuration for approval/denial/comments
    const genericCommentModals = [
        {
            show: showApprove,
            setter: setShowApprove,
            title: 'approve_request',
            setRow: setRow,
            row: row,
            status: STATUS_MODEL.APPROVED,
            module: module,
            endPoint: UpdateStatusByInvitationId
        },
        {
            show: showDenied,
            setter: setShowDenied,
            title: 'decline_comment',
            setRow: setRow,
            row: row,
            status: STATUS_MODEL.REJECTED,
            module: module,
            endPoint: UpdateStatusByInvitationId
        },
        {
            show: showIssueComment,
            setter: setShowIssueComment,
            title: 'request_changes',
            setRow: setRow,
            row: row,
            status: STATUS_MODEL.CHANGES_REQUESTED,
            module: module,
            endPoint: UpdateStatusByInvitationId
        },
    ];

    useEffect(() => {
        let aux = null;
        if (resultsToShow?.invitation?.visitorStatusId === STATUS_MODEL.CANCELED) {
            aux = {...getStatusConfig(resultsToShow.invitation.visitorStatusId), toast:'canceled_by_visitor' };
        }else if (resultsToShow?.invitation?.statusId) {
            aux = getStatusConfig(resultsToShow.invitation.statusId);
        }
        if(aux !== null){
            setShowButtonsToApprove(aux.id !== STATUS_MODEL.REJECTED &&
                aux.id !== STATUS_MODEL.APPROVED &&
                aux.id !== STATUS_MODEL.CANCELED &&
                aux.id !== STATUS_MODEL.CHANGES_REQUESTED);
        }

        setCurrentStatusConfig(aux);
    }, [resultsToShow?.invitation?.statusId, resultsToShow?.invitation?.visitorStatusId, modified]);


    // Load data on first render
    useEffect(() => {
        getData();
    }, []);

    // Refresh data when something changes
    useEffect(() => {
        if (modified) {
            getData();
            setModified(false);
        }
    }, [modified]);

    // Fetch invitation data from API
    const getData = () => {
        dispatch(GetInvitationById(userId)).then(({ payload: { data: { data, success } } }) => {
            if (success === true) {
                setResultsToShow(data);
            }
        });
    };

    // Generate styles based on approval status
    const styles = CustomFieldCardStyle(currentStatusConfig?.id, disabled);

    const handleOnBack = () => {
        navigate(backUrl.pathname, {
            state: backUrl.state
        });
    }

    useEffect(() => {
        if (resultsToShow?.fields?.some(field => field.value === null || field.value === '')) {
            setPendingToUpload(false);
        }
    }, [resultsToShow]);

    return {
        resultsToShow,
        setShowApprove,
        setShowDenied,
        setShowIssueComment,
        row,
        setRow,
        styles,
        genericCommentModals,
        setModified,
        modified,
        t,
        disabled,
        dispatch,
        currentStatusConfig,
        handleOnBack,
        pendingToUpload,
        isOverdue,
        showButtonsToApprove
    };
}
